/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';
import Iframe from 'react-iframe';

export interface IYouTube {
  headingText?: string;
  videoLink?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class YouTubeBox extends Component {
  private readonly youtube: IYouTube = {
    headingText: 'watch how it is done!',
    videoLink: 'https://www.youtube.com/embed/TWNi6jnr0QQ',
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12'>
            <h5 className='diy-small-heading'>{this.youtube.headingText}</h5>
          </div>

          <div className='col-lg-12 col-md-12'>
            <div className='diy-youtube-box'>
              <Iframe
                url='https://www.youtube.com/embed/TWNi6jnr0QQ'
                width='100%'
                height='100%'
                frameBorder={0}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default YouTubeBox;
